import { Heart } from "lucide-react";
import { useSiteBranding } from "@/hooks/useSiteBranding";

/** The same site identity in the public and signed-in navigation. */
export function SiteBrand({ className = "" }: { className?: string }) {
  const { data: branding } = useSiteBranding();
  return (
    <span className={`inline-flex items-center gap-2 font-sans font-bold text-foreground ${className}`}>
      {branding?.logoUrl ? (
        <img src={branding.logoUrl} alt="" className="h-6 w-6 shrink-0 object-contain" />
      ) : (
        <Heart className="h-5 w-5 shrink-0 text-primary" strokeWidth={2} aria-hidden="true" />
      )}
      <span>{branding?.siteTitle || "Perfecte"} {branding?.siteTitleAccent || "Zorgmatch"}</span>
    </span>
  );
}